import React from 'react';
import PaymentMain from './PaymentMain';

import '../../../Content/mhd-custom/src/scss/mhd-custom.scss';
import '../../semantic/dist/semantic.css';
import '../overrides.scss';

export default function App() {
  return <PaymentMain />;
}



// WEBPACK FOOTER //
// ./src/paymentApp/paymentApp.js